import { i18n } from "translate/i18n";

export const youWereInvited = i18n.t("messages.youWereInvited");
export const loginToJoin = i18n.t("messages.loginToJoin");
